import { resolveProp } from '@clearscore/helpers.resolve-props';

import initialNormalisedState from './initial-normalised-state';

export default (payload) => {
    const id = resolveProp('product.productId', payload);
    if (!(id && payload.details && payload.details.length)) return initialNormalisedState;

    return {
        byId: {
            [id]: [...payload.details],
        },
        allIds: [id],
    };
};
